import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { CommonService } from "src/app/core/services/common.service";
import { ListValueService } from "src/app/core/services/list-value.service";
import { SweetAlertService } from "src/app/core/services/sweet-alert.service";
import { TokenService } from "src/app/core/services/token.service";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { SolicitudPlacaService } from "src/app/placa/services/solicitud-placa.service";
import { TranslateService } from "@ngx-translate/core";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import { Router } from "@angular/router";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { AppConstants } from "../../../constants/app.constants";
import { ValidateVehiculo } from "../../../certificates/models";

@Component({
  selector: "app-request-placa-reedicion-solicitud",
  templateUrl: "./request-placa-reedicion-solicitud.component.html",
  styleUrls: ["./request-placa-reedicion-solicitud.component.css"],
})
export class RequestPlacaReedicionSolicitudComponent implements OnInit {
  public roles = AppConstants.roles;
  solicitudDatos;

  @ViewChild("confirmSwal")
  public readonly confirmSwal!: SwalComponent;

  @ViewChild("fileHomologador") fileHomologador: any;
  @ViewChild("fileImportador") fileImportador: any;

  @ViewChild("selectModelo") selectModelo: any;
  @ViewChild("selectTipoMotor") selectTipoMotor: any;
  @ViewChild("selectTipoCambio") selectTipoCambio: any;
  @ViewChild("selectMotivoReedicion") selectMotivoReedicion: any;
  @ViewChild("selectTipoPlaca") selectTipoPlaca: any;

  file = {
    name: "",
    data: null,
  };

  lists = {
    modeloList: [],
    tipoMotorList: [],
    tipoCambio: [],
    valueSelectTipoPlaca: [],
    tipoPlaca: [],
    motivoReedicion: [],
  };

  requestText: string;
  vehiculoValid: boolean;
  routing = RoutingConstants.placaRequest;

  constructor(
    private solicitudPlacaService: SolicitudPlacaService,
    private toastrAlertService: ToastrAlertService,
    private sweetAlertService: SweetAlertService,
    private commonService: CommonService,
    private router: Router,
    private listValueService: ListValueService,
    private translateService: TranslateService,
    private tokenService: TokenService
  ) {}

  ngOnInit(): void {
    this.requestText = this.translateService.instant("messages.requestText");
    this.initFormGroupIndividual();
  }

  onSave() {
    let invalidFields = this.commonService.findInvalidControls(
      this.solicitudDatos.controls
    );
    if (invalidFields.length > 0) {
      let text = this.commonService.getValueOfLabelsById(invalidFields);
      this.toastrAlertService.toastrFail(text);
    } else {
      if (
        this.solicitudDatos.value.type == "individual" &&
        this.fileIsMandatory(this.file)
      ) {
        this.sweetAlertService.sweetAlertLoading();
        this.solicitudDatos.get("bastidor")?.enable();
        this.solicitudPlacaService
          .individual(this.solicitudDatos, this.file)
          .subscribe(
            (data) => {
              this.sweetAlertService.sweetAlertClose();
              this.confirmSwal.html = data.mensaje;
              this.confirmSwal.fire();
            },
            (err) => {
              this.sweetAlertService.sweetAlertClose();
              this.toastrAlertService.toastrFail(err.error.mensaje);
            }
          );
        this.solicitudDatos.get("bastidor")?.disable();
      } else if (
        this.solicitudDatos.value.type == "homologar" &&
        this.fileIsMandatory(this.file)
      ) {
        this.sweetAlertService.sweetAlertLoading();
        this.solicitudPlacaService
          .homologador(this.solicitudDatos, this.file)
          .subscribe(
            (data) => {
              let mensaje =
                "Sus solicitudes han pasado a estado 'PA - pendiente de análisis' y serán analizadas en breve.";
              mensaje +=
                " Utilice la función Consulta para revisar el estado de las peticiones. Los números de solicitud asignados son: </br>";

              data.forEach((e) => {
                mensaje += "    " + e + "</br>";
              });

              this.sweetAlertService.sweetAlertClose();
              this.confirmSwal.html = mensaje;
              this.confirmSwal.fire();
            },
            (err) => {
              this.fileHomologador.nativeElement.value = null;
              this.file.data = null;
              this.file.name = null;
              this.sweetAlertService.sweetAlertClose();
              this.toastrAlertService.toastrFail(err.error.mensaje);
            }
          );
      } else if (
        this.solicitudDatos.value.type == "importador" &&
        this.fileIsMandatory(this.file)
      ) {
        this.sweetAlertService.sweetAlertLoading();
        this.solicitudPlacaService.importador(this.file).subscribe(
          (data) => {
            let mensaje =
              "Sus solicitudes han pasado a estado 'PA - pendiente de análisis' y serán analizadas en breve.";
            mensaje +=
              " Utilice la función Consulta para revisar el estado de las peticiones. Los números de solicitud asignados son: </br>";

            data.forEach((e) => {
              mensaje += "     " + e + "</br>";
            });

            this.sweetAlertService.sweetAlertClose();
            this.confirmSwal.html = mensaje;
            this.confirmSwal.fire();
          },
          (err) => {
            this.fileImportador.nativeElement.value = null;
            this.file.data = null;
            this.file.name = null;
            this.sweetAlertService.sweetAlertClose();
            this.toastrAlertService.toastrFail(err.error.mensaje);
          }
        );
      } else {
        this.sweetAlertService.sweetAlertClose();
      }
    }
  }

  fileIsMandatory(file: any): boolean {
    if (!file.data && file.name == "") {
      this.toastrAlertService.toastrFail("El fichero es obligatorio");
      return false;
    }
    return true;
  }

  initFormGroupIndividual() {
    if (this.selectModelo) delete this.selectModelo.item;
    if (this.selectTipoMotor) delete this.selectTipoMotor.item;
    if (this.selectTipoCambio) delete this.selectTipoCambio.item;
    if (this.selectMotivoReedicion) delete this.selectMotivoReedicion.item;
    if (this.selectTipoPlaca) delete this.selectTipoPlaca.item;

    this.file.data = null;
    this.file.name = "";
    this.lists = {
      modeloList: [],
      tipoMotorList: [],
      tipoCambio: [],
      valueSelectTipoPlaca: [],
      tipoPlaca: [],
      motivoReedicion: [],
    };

    this.solicitudDatos = new FormGroup({
      bastidor: new FormControl("", [Validators.required]),
      modelo: new FormControl("", [Validators.required]),
      tipoMotor: new FormControl("", [Validators.required]),
      tipoCambio: new FormControl("", [Validators.required]),
      numPuertas: new FormControl("", [Validators.required]),
      motivoReedicion: new FormControl("", [Validators.required]),
      tipoPlaca: new FormControl("", [Validators.required]),
      observaciones: new FormControl(""),
      type: new FormControl("individual", Validators.required),
    });

    this.vehiculoValid = false;
  }

  initFormGroupHomologar() {
    this.file.data = null;
    this.file.name = "";
    this.solicitudDatos = new FormGroup({
      facturar: new FormControl("0", Validators.required),
      type: new FormControl("homologar", Validators.required),
    });
  }

  initFormGroupImportador() {
    this.file.data = null;
    this.file.name = "";
    this.solicitudDatos = new FormGroup({
      type: new FormControl("importador", Validators.required),
    });
  }

  searchCodigoMotor() {
    this.sweetAlertService.sweetAlertLoading();
    this.listValueService
      .listCodigoMotor(this.solicitudDatos.getRawValue().bastidor)
      .subscribe(
        (data) => {
          this.lists.tipoMotorList = data;
          this.sweetAlertService.sweetAlertClose();
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
          this.sweetAlertService.sweetAlertClose();
        }
      );
  }

  searchModeloTipo() {
    this.sweetAlertService.sweetAlertLoading();
    this.listValueService
      .listModeloTipo(this.solicitudDatos.getRawValue().bastidor)
      .subscribe(
        (data) => {
          this.lists.modeloList = data;
          this.lists.tipoMotorList = data[1];
          this.sweetAlertService.sweetAlertClose();
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
          this.sweetAlertService.sweetAlertClose();
        }
      );
  }

  loadListMotivosReedicion() {
    this.listValueService.listMotivosReedicion().subscribe(
      (data) => {
        data.sort((a, b) => (a.mrId > b.mrId ? 1 : b.mrId > a.mrId ? -1 : 0));
        this.lists.motivoReedicion = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  loadListTipoPlaca() {
    this.listValueService.listTipoPlaca().subscribe(
      (data) => {
        this.lists.tipoPlaca = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  validateVehiculo() {
    let dto: ValidateVehiculo = {
      bastidor: this.solicitudDatos.getRawValue().bastidor,
      matricula: "0000BBB",
    };

    this.sweetAlertService.sweetAlertLoading();
    this.solicitudPlacaService.validateVehiculoBastidor(dto).subscribe(
      (data) => {
        this.vehiculoValid = true;

        this.fillLists();
      },
      (err) => {
        this.toastrAlertService.toastrFail(
          err.error.mensaje ? err.error.mensaje : "Error al validar el bastidor"
        );
        this.sweetAlertService.sweetAlertClose();
      }
    );
  }

  public fillLists() {
    this.solicitudDatos.patchValue({
      bastidor: this.solicitudDatos.getRawValue().bastidor,
    });

    this.lists = {
      modeloList: [],
      tipoMotorList: [],
      tipoCambio: [],
      valueSelectTipoPlaca: [],
      tipoPlaca: [],
      motivoReedicion: [],
    };

    this.searchModeloTipo();
    this.searchCodigoMotor();
    this.loadListMotivosReedicion();
    this.loadListTipoPlaca();

    this.sweetAlertService.sweetAlertClose();
  }

  loadCambioList() {
    this.listValueService
      .listTipoCambio(
        this.solicitudDatos.getRawValue().bastidor,
        this.solicitudDatos.getRawValue().tipoMotor
      )
      .subscribe(
        (data) => {
          this.lists.tipoCambio = this.eliminaTiposCambioConDescrDuplicada(
            data[0]
          );
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }

  eliminaTiposCambioConDescrDuplicada(conDuplicados) {
    let sinDuplicados = [];
    conDuplicados.forEach((tipoCambio) => {
      if (
        sinDuplicados.find(
          (tipoCambioDuplicado) => tipoCambioDuplicado.Texto == tipoCambio.Texto
        ) == null
      ) {
        sinDuplicados.push(tipoCambio);
      }
    });
    return sinDuplicados;
  }

  changePeticionType(e) {
    if (e.target.value == "individual") {
      this.initFormGroupIndividual();
    } else if (e.target.value == "homologar") {
      this.initFormGroupHomologar();
    } else if (e.target.value == "importador") {
      this.initFormGroupImportador();
    }
  }

  setFacturar(e) {
    this.solicitudDatos.value.facturar = e.target.value;
  }

  handleFileInput(fileInput: any) {
    if (
      Array.from(fileInput.target.files).filter(
        (file: File) =>
          file.name.length > AppConstants.maximaLongitudNombreFichero
      ).length > 0
    ) {
      let message = this.translateService.instant(
        "messages.maxFileNameExceeded"
      );
      this.toastrAlertService.toastrFail(message);
      return;
    }

    if (
      Array.from(fileInput.target.files).filter(
        (file: File) => file.size > AppConstants.tamanyoMaximoFicheroEnBytes
      ).length > 0
    ) {
      let message = this.translateService.instant(
        "messages.maxFileSizeExceeded"
      );
      this.toastrAlertService.toastrFail(message);
      return;
    }

    this.file.name = fileInput.target.files[0].name;
    const reader = new FileReader();
    reader.onload = (e: any) => {
      let blob = this.commonService.castToBlob(e.target.result);
      this.file.data = blob;
    };
    reader.readAsDataURL(fileInput.target.files[0]);
  }

  onDownload(type: string) {
    let titleFile;
    if (type == "H") {
      titleFile = "PlantillaHomologador.xls";
    } else {
      titleFile = "PlantillaImportador.xls";
    }
    this.solicitudPlacaService.getFile(type).subscribe(
      (data) => {
        this.commonService.downloadFile(data, titleFile);
        this.toastrAlertService.toastrSuccess("Archivo descargado");
      },
      (err) => {
        this.toastrAlertService.toastFailBlob(err.error);
      }
    );
  }

  valueSelectModelo(e) {
    if (e.item && e.item.Valor) {
      this.solicitudDatos.patchValue({
        modelo: e.item.Valor,
      });
    }
  }

  valueSelectTipoMotor(e) {
    if (e.item && e.item.Valor) {
      this.solicitudDatos.patchValue({
        tipoMotor: e.item.Valor,
      });
      this.loadCambioList();
    }
  }

  valueSelectTipoCambio(e) {
    if (e.item && e.item.Valor) {
      this.solicitudDatos.patchValue({
        tipoCambio: e.item.Valor,
      });
    }
  }

  valueSelectMotivoReedicion(e) {
    if (e.item && e.item.mrId) {
      this.solicitudDatos.patchValue({
        motivoReedicion: e.item.mrId,
      });
    }
  }

  valueSelectTipoPlaca(e) {
    if (e.item && e.item.ValorPlaca) {
      this.solicitudDatos.patchValue({
        tipoPlaca: e.item.ValorPlaca,
      });
    }
  }

  goList() {
    this.router.navigate([this.routing.mailBoxList]);
  }

  createAnotherRequest() {
    window.location.reload();
  }

  public setNumber() {
    if (
      !this.solicitudDatos.value.numPuertas ||
      this.solicitudDatos.value.numPuertas < AppConstants.minNumPuertas
    ) {
      let message =
        document.getElementById("numPuertas").textContent +
        this.translateService.instant("messages.numeroMinInt");
      this.toastrAlertService.toastrFail(message);
      this.solicitudDatos.patchValue({
        numPuertas: AppConstants.defaultNumPuertas,
      });
    }
  }
}
